import { Dispatch } from "redux";
import {
  CareerService,
  Player,
  PlayerCard,
  PlayerCareer,
  PlayerRatingMatch,
  PlayerSeason,
  PlayerService,
  PlayerRatingService,
} from "../../client/api";
import { PlayerPageActions, PlayerPageActionTypes } from "./types";
import { fetchError } from "./all";
import { IDType } from "../../config/types";

export function fetchPlayer(
  dispatch: Dispatch<PlayerPageActions>,
  playerId: IDType
): void {
  dispatch({ type: PlayerPageActionTypes.FETCH_PLAYER });
  PlayerService.getPlayerPlayerPlayerIdGet(Number(playerId)).then(
    (response: Player) => {
      dispatch({
        type: PlayerPageActionTypes.FETCH_PLAYER_SUCCESS,
        payload: { id: playerId, response, fetchDate: new Date() },
      });
    },
    (error: unknown) => fetchError(error, PlayerPageActionTypes.FETCH_ERROR, dispatch)
  );
}

export function fetchPlayerCard(
  dispatch: Dispatch<PlayerPageActions>,
  playerId: IDType
): void {
  dispatch({ type: PlayerPageActionTypes.FETCH_PLAYER_CARD });
  PlayerService.getPlayerCardPlayerCardPlayerIdGet(Number(playerId)).then(
    (response: PlayerCard) => {
      dispatch({
        type: PlayerPageActionTypes.FETCH_PLAYER_CARD_SUCCESS,
        payload: { id: playerId, response, fetchDate: new Date() },
      });
    },
    (error: unknown) => fetchError(error, PlayerPageActionTypes.FETCH_ERROR, dispatch)
  );
}

export function fetchPlayerCareer(
  dispatch: Dispatch<PlayerPageActions>,
  playerId: IDType
): void {
  dispatch({ type: PlayerPageActionTypes.FETCH_PLAYER_CAREER });
  CareerService.getPlayerCareerPlayerCareerPlayerIdGet(Number(playerId)).then(
    (response: PlayerCareer) => {
      dispatch({
        type: PlayerPageActionTypes.FETCH_PLAYER_CAREER_SUCCESS,
        payload: { id: playerId, response, fetchDate: new Date() },
      });
    },
    (error: unknown) => fetchError(error, PlayerPageActionTypes.FETCH_ERROR, dispatch)
  );
}

export function fetchPlayerMatches(
  dispatch: Dispatch<PlayerPageActions>,
  playerId: IDType
): void {
  dispatch({ type: PlayerPageActionTypes.FETCH_PLAYER_MATCHES });
  PlayerRatingService.getPlayerRatingWithMatchesPlayerRatingPlayerPlayerIdGet(
    Number(playerId)
  ).then(
    (response: PlayerRatingMatch[]) => {
      const sorted = [...response].sort(
        (a: PlayerRatingMatch, b: PlayerRatingMatch) =>
          new Date(b.match.startTime).getTime() -
          new Date(a.match.startTime).getTime()
      );
      dispatch({
        type: PlayerPageActionTypes.FETCH_PLAYER_MATCHES_SUCCESS,
        payload: { id: playerId, response: sorted, fetchDate: new Date() },
      });
    },
    (error: unknown) => fetchError(error, PlayerPageActionTypes.FETCH_ERROR, dispatch)
  );
}

export function fetchPlayerSeason(
  dispatch: Dispatch<PlayerPageActions>,
  playerId: IDType,
  leagueId: IDType
): void {
  dispatch({ type: PlayerPageActionTypes.FETCH_PLAYER_SEASON });
  PlayerService.getPlayerSeasonPlayerSeasonPlayerIdLeagueIdGet(
    Number(playerId),
    Number(leagueId)
  ).then(
    (response: PlayerSeason[]) => {
      dispatch({
        type: PlayerPageActionTypes.FETCH_PLAYER_SEASON_SUCCESS,
        payload: {
          key: `${playerId}_${leagueId}`,
          response,
          fetchDate: new Date(),
        },
      });
    },
    (error: unknown) => fetchError(error, PlayerPageActionTypes.FETCH_ERROR, dispatch)
  );
}

export function fetchAllPlayerData(
  dispatch: Dispatch<PlayerPageActions>,
  playerId: IDType
): void {
  fetchPlayer(dispatch, playerId);
  fetchPlayerCard(dispatch, playerId);
  fetchPlayerCareer(dispatch, playerId);
  fetchPlayerMatches(dispatch, playerId);
}
